import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { containerVariants, textVariants, imageVariants } from '../script/animation';


const Kurumsal = () => {
    const { t } = useTranslation();

    return (
        <motion.div className=''>
        
            {/* Banner */}
            <motion.div variants={containerVariants}
                initial="hidden"
                animate="visible"
                className='w-full bg-red grid grid-cols-11 relative min-h-[30vh]'>
                
                <motion.img variants={imageVariants} src='/images/general-banner.jpg' className='w-full h-full object-cover absolute' />

                <div className='col-start-2 col-span-9 lg:col-start-3 lg:col-span-7 z-50 py-20 grid grid-cols-1 md:grid-cols-2 md:gap-10 lg:gap-20 content-start'>
                    <div className='text-white'>
                        <motion.h1 variants={textVariants} className='text-65 font-bold nunito-sans mb-5'>
                            {t('kurumsal')}
                        </motion.h1>
                    </div>
                </div>
            </motion.div>

            {/* Hakkımızda */}
            <motion.div variants={containerVariants}
                initial="hidden"
                animate="visible"
                className='w-full grid grid-cols-11 relative bg-white'>
                <div className='col-start-2 col-span-9 lg:col-start-3 lg:col-span-5 z-50 py-20'>
                    <motion.h2 variants={textVariants} className='text-genesisBlue text-56 mb-3'>{t('hakkimizda')}</motion.h2>
                    <motion.p variants={textVariants} className='text-customGray text-18'>
                        {t('hakkimizda_text')}
                    </motion.p>
                </div>
            </motion.div>

            {/* Kurumsal Görsel */}
            <motion.img variants={imageVariants} src='/images/kurumsal.jpg' className='h-[37vh] w-full object-cover object-center' />

            {/* Vizyon */}
            <motion.div variants={containerVariants}
                initial="hidden"
                animate="visible"
                className='w-full grid grid-cols-11 relative bg-white'>
                <div className='col-start-2 col-span-9 lg:col-start-3 lg:col-span-5 z-50 py-20'>
                    <motion.h2 variants={textVariants} className='text-genesisBlue text-56 mb-3'>{t('vizyon')}</motion.h2>
                    <motion.p variants={textVariants} className='text-customGray text-18'>
                        {t('vizyon_text')}
                    </motion.p>
                </div>
            </motion.div>

            {/* Misyon */}
            <motion.div variants={containerVariants}
                initial="hidden"
                animate="visible"
                className='w-full grid grid-cols-11 relative bg-white'>
                <div className='col-start-2 col-span-9 lg:col-start-3 lg:col-span-5 z-50 pb-20'>
                    <motion.h2 variants={textVariants} className='text-genesisBlue text-56 mb-3'>{t('misyon')}</motion.h2>
                    <motion.p variants={textVariants} className='text-customGray text-18'>
                        {t('misyon_text')}
                    </motion.p>
                </div>
            </motion.div>
        </motion.div>
    );
}

export default Kurumsal;
